import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js';
import { Line, Bar, Pie, Scatter } from 'react-chartjs-2';

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const DataVisualization = ({ visualization }) => {
  if (!visualization) return null;

  const { type, labels, datasets, options } = visualization;

  console.log('Visualization data received:', {
    type,
    labels,
    datasets,
    options
  });

  // Ensure each dataset has its colors preserved
  const chartProps = {
    data: {
      labels,
      datasets: datasets.map(dataset => {
        console.log('Processing dataset:', dataset);
        return {
          ...dataset,
          // Preserve the colors from backend but provide defaults if missing
          borderColor: dataset.borderColor || 'rgb(75, 192, 192)',
          backgroundColor: dataset.backgroundColor || 'rgba(75, 192, 192, 0.5)',
          borderWidth: dataset.borderWidth || 2,
          // Add specific chart type properties
          ...(type.toLowerCase() === 'line' && {
            tension: dataset.tension || 0.1,
            fill: dataset.fill !== undefined ? dataset.fill : false
          }),
          ...(type.toLowerCase() === 'bar' && {
            borderRadius: dataset.borderRadius || 4
          })
        };
      })
    },
    options: {
      ...options,
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        ...options?.plugins,
        legend: {
          ...options?.plugins?.legend,
          position: 'top',
          labels: {
            usePointStyle: true,
            padding: 20,
            font: {
              size: 12
            }
          }
        }
      },
      scales: {
        ...options?.scales,
        y: {
          ...options?.scales?.y,
          beginAtZero: true,
          ticks: {
            precision: 0
          }
        }
      }
    }
  };

  console.log('Final chartProps:', chartProps);

  const renderChart = () => {
    switch (type.toLowerCase()) {
      case 'line':
        return <Line {...chartProps} />;
      case 'bar':
        return <Bar {...chartProps} />;
      case 'pie':
        return <Pie {...chartProps} />;
      case 'scatter':
        return <Scatter {...chartProps} />;
      default:
        return <Bar {...chartProps} />;
    }
  };

  return (
    <div className="w-full h-[400px] p-4 bg-white/50 dark:bg-gray-800/50 rounded-lg shadow-sm">
      {renderChart()}
    </div>
  );
};

export default DataVisualization;